import { IUseGameSeasonClawMachinePrizeClaims, AdminGameSeasonClawMachinePrizeClaimsEndpoints, fetcher } from "@olagg/api-hooks";
import { AdminGameSeasonClawMachinePrizeClaim } from "@olagg/db-types";
import { useState } from "react";

interface ClaimsResponse {
  gameSeasonClawMachinePrizeClaims: AdminGameSeasonClawMachinePrizeClaim[]
  meta: {
    count: number
  }
}

const useClawPrizeClaims = () => {
  const [loading, setLoading] = useState(false)

  const getClawPrizeClaims = async (filter: IUseGameSeasonClawMachinePrizeClaims): Promise<ClaimsResponse> => {
    try {
      setLoading(true)
      const endpoint = AdminGameSeasonClawMachinePrizeClaimsEndpoints.all(filter)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching claw machine prize claims:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    getClawPrizeClaims
  }
}

export default useClawPrizeClaims;